import { buildLqip, buildSrcSet, ImageQuality, isOptimizable } from "./cloudinaryImage";

export type ImageRatio = { width: number; height: number };

export type ImageLoader = {
	/** Responsive srcset for the given candidate widths, or undefined when the src can't be optimized. */
	srcSet: (
		src: string,
		ratio: ImageRatio,
		widths: number[],
		quality: ImageQuality
	) => string | undefined;
	/** Low-quality blur placeholder, or undefined when unavailable. */
	lqip: (src: string) => string | undefined;
};

export const cloudinaryLoader: ImageLoader = {
	srcSet: (src, ratio, widths, quality) =>
		isOptimizable(src) ? buildSrcSet(src, ratio, widths, quality) : undefined,
	lqip: src => (isOptimizable(src) ? buildLqip(src) : undefined),
};
